import React from 'react'
import styled from 'styled-components';
import { motion } from 'framer-motion'

const Box = styled(motion.div)`
width: calc(10rem + 15vw);
text-decoration: none;
user-select:none;
height: 20rem;
padding: 1rem;
color: ${props => props.theme.text};
border: 2px solid${props => props.theme.text}
backdrop-filter: blur(2px);
box-shadow: 0 0 1rem 0 rgba(0,0,0,0.2);
cursor: pointer;

display: flex;
flex-direction: column;
z-index: 5;

&:hover{
    color: ${props => props.theme.body};
    background-color: ${props => props.theme.text};
    transition: all 0.3s ease
}
background-color:#fff;
box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
`;

const Image = styled.div`
    background-image:${props => `url(${props.img})`};
    width: 100%;
    height: 60%;
    background-size: cover;
    border: 1px solid transparent;
    background-position: center center;

    ${Box}:hover &{
        border: 2px solid ${props => props.theme.body};
        transition: all 0.3s ease
    }


`;

const Title = styled.h3`
    color: inherit;
    padding: 0.5rem 0;
    padding-top: 1rem;
    font-family: 'Karla', sans-serif;
    font-weight: 700;
    border-bottom: 1px solid ${props => props.theme.text};

    ${Box}:hover &{
        border-bottom: 2px solid ${props => props.theme.body};
        transition: all 0.3s ease
    }
    `;

const HashTags = styled.div`
    padding:0.5rem 0;
`

const Tag = styled.span`
padding-right: 0.5rem;
`
const Date = styled.span`
    padding: 0.5rem 0;
`

const Container = styled(motion.div)``

const Item ={
    hidden : {
      scale: 0
    },
    show:{
      scale: 1,
      transition: {
        type:'spring',
        duration: 0.5
      }
    }
  }


const BlogComponent = (props) => {
    const {name, tags, date, imgSrc} = props.blog;

  return (
   <Container 
    variants={Item}
   >
     <Box 
    
    >
        <Image img= {imgSrc}/>
        <Title>{name}</Title>
        <HashTags>
            {
                tags.map((t,id)=>{
                    return <Tag key={id}>#{t}</Tag>
                })
            }
        </HashTags>
        <Date>
            {date}
        </Date>
    </Box>
   </Container>
  )
}

export default BlogComponent